import React from "react"
import PropTypes from "prop-types"
import BaseChart from "./BaseChart"

// made xAxisCategories options. This lets you use the series name if you use multiple
// series rather than just naming a single series' data.
// added drilldown
// added stackBars option

export class BarChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNumber: 1
    };
  }

  static propTypes = {
    height: PropTypes.number,
    yAxisMin: PropTypes.number,
    yAxisText: PropTypes.string.isRequired,
    xAxisCategories: PropTypes.array,
    series: PropTypes.array.isRequired,
    drilldown: PropTypes.array,
    colors: PropTypes.array,
    type: PropTypes.oneOf(["bar", "column"]).isRequired,
    decimals: PropTypes.number,
    showLegend: PropTypes.bool,
    stackBars: PropTypes.oneOf([undefined, "normal", "percent"])
  };

  render() {
    let {
      xAxisCategories,
      series,
      drilldown,
      height,
      yAxisMin,
      yAxisText,
      colors,
      type,
      decimals,
      showLegend,
      stackBars
    } = this.props;

    yAxisMin = yAxisMin || 0;
    showLegend = showLegend || false;

    return (
      <BaseChart
        decimals={decimals}
        colors={colors}
        options={{
          chart: {
            type: type,
            height: height
          },
          title: {
            text: null
          },
          series: series,
          drilldown: { series: drilldown },
          yAxis: {
            min: yAxisMin,
            title: {
              text: yAxisText
            },
            lineWidth: 1,
            reversedStacks: false
          },
          xAxis: {
            ...(xAxisCategories
            ? {
                categories: xAxisCategories
              }
            : {
                type: "category"
              })
          },
          legend: {
            enabled: showLegend,
            ...(showLegend
              ? {
                  squareSymbol: true,
                  symbolRadius: 3
                }
              : {})
          },
          plotOptions:{
            series: {
              stacking: stackBars
            }
          }
        }}
      />
    );
  }
}

export default BarChart;
